import { ShopsApiClient } from '@fourthwall/services/dist/ShopsApiClient'
import { createQueryHook } from '@fourthwall/utils'
import { decodeHtmlEntities } from '@fourthwall/utils/dist/sanitize'

export const useConnectedShopsQuery = createQueryHook(ShopsApiClient.getConnectedShops, {
  queryKey: ['connectedShops'],
  select: (data) => {
    data.shops = data.shops.map((shop) => ({
      ...shop,
      name: decodeHtmlEntities(shop.name),
      creatorName: decodeHtmlEntities(shop.creatorName),
      description: decodeHtmlEntities(shop.description),
    }))

    return data
  },
})
